webpackJsonp([32],{

/***/ 100:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return wxSetTitle; });
var wxSetTitle = function wxSetTitle(title) {
    document.title = title;
    var mobile = navigator.userAgent.toLowerCase();
    if (/iphone|ipad|ipod/.test(mobile)) {
        var iframe = document.createElement('iframe');
        iframe.style.visibility = 'hidden';

        var iframeCallback = function iframeCallback() {
            setTimeout(function () {
                iframe.removeEventListener('load', iframeCallback);
                document.body.removeChild(iframe);
            }, 0);
        };
        iframe.addEventListener('load', iframeCallback);
        document.body.appendChild(iframe);
    }
};

/***/ }),

/***/ 101:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appStore_index_js__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__menuTree_index_js__ = __webpack_require__(173);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    modules: {
        app: __WEBPACK_IMPORTED_MODULE_2__appStore_index_js__["a" /* default */],
        menu: __WEBPACK_IMPORTED_MODULE_3__menuTree_index_js__["a" /* default */]
    }
});
/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 103:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 104:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 105:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 106:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 107:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 108:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__moudules_login__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__moudules_home__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__moudules_menu__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__moudules_role__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__moudules_accountManagement__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__moudules_book__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__moudules_experienceManagement__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__moudules_banner__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__moudules_user__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__moudules_experienceNote__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__moudules_academicBooks__ = __webpack_require__(160);












/* harmony default export */ __webpack_exports__["a"] = ({
  login: __WEBPACK_IMPORTED_MODULE_0__moudules_login__,
  home: __WEBPACK_IMPORTED_MODULE_1__moudules_home__,
  menu: __WEBPACK_IMPORTED_MODULE_2__moudules_menu__,
  role: __WEBPACK_IMPORTED_MODULE_3__moudules_role__,
  accountManagement: __WEBPACK_IMPORTED_MODULE_4__moudules_accountManagement__,
  book: __WEBPACK_IMPORTED_MODULE_5__moudules_book__,
  experienceManagement: __WEBPACK_IMPORTED_MODULE_6__moudules_experienceManagement__,
  banner: __WEBPACK_IMPORTED_MODULE_7__moudules_banner__,
  user: __WEBPACK_IMPORTED_MODULE_8__moudules_user__,
  experienceNote: __WEBPACK_IMPORTED_MODULE_9__moudules_experienceNote__,
  academicBooks: __WEBPACK_IMPORTED_MODULE_10__moudules_academicBooks__
});

/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBookList", function() { return getBookList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateStatus", function() { return updateStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addBook", function() { return addBook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateBook", function() { return updateBook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getQuestionList", function() { return getQuestionList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editBookMenu", function() { return editBookMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBookDetail", function() { return getBookDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addQuestion", function() { return addQuestion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "viewQuestion", function() { return viewQuestion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editQuestion", function() { return editQuestion; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(7);


var getBookList = function getBookList(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: "/con/custom/book/getBookList",
    method: "GET",
    data: data
  });
};

var updateStatus = function updateStatus(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: "/con/custom/book/updateStatus",
    method: "GET",
    data: data
  });
};

var addBook = function addBook(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: "/con/custom/book/addBook",
    method: "GET",
    data: data
  });
};

var updateBook = function updateBook(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: "/con/custom/book/updateBook",
    method: "GET",
    data: data
  });
};

var getQuestionList = function getQuestionList(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: "/con/manage/question/catalogQuestions",
    method: "GET",
    data: data
  });
};

var editBookMenu = function editBookMenu(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: "/con/custom/book/updateBookCatalog",
    method: "GET",
    data: data
  });
};

var getBookDetail = function getBookDetail(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: "/con/custom/book/getBookDetail",
    method: "GET",
    data: data
  });
};

var addQuestion = function addQuestion(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: "/con/manage/question/addQuestion",
    method: "POST",
    data: data
  });
};

var viewQuestion = function viewQuestion(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: "/con/manage/question/getQuestionById",
    method: "GET",
    data: data
  });
};

var editQuestion = function editQuestion(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: "/con/manage/question/edit",
    method: "POST",
    data: data
  });
};

/***/ }),

/***/ 161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserList", function() { return getUserList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUpdate_user_status", function() { return getUpdate_user_status; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Postreset_passwd", function() { return Postreset_passwd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAllRole", function() { return getAllRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postAddAccount", function() { return postAddAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postDelete", function() { return postDelete; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(7);


var getUserList = function getUserList(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/user/list',
    method: 'POST',
    data: data
  });
};

var getUpdate_user_status = function getUpdate_user_status(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/user/update_user_status',
    method: 'POST',
    data: data
  });
};

var Postreset_passwd = function Postreset_passwd(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/user/reset_passwd',
    method: 'POST',
    data: data
  });
};

var getAllRole = function getAllRole(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/role/get_all_role',
    method: 'POST'
  });
};

var postAddAccount = function postAddAccount(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/user/save',
    method: 'POST',
    data: data
  });
};

var postDelete = function postDelete(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/user/delete',
    method: 'POST',
    data: data
  });
};

/***/ }),

/***/ 162:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBannerList", function() { return getBannerList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postDeleteRow", function() { return postDeleteRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addBanner", function() { return addBanner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postUpdateBanner", function() { return postUpdateBanner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postEditBanner", function() { return postEditBanner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBannerDeletail", function() { return getBannerDeletail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBshelves_list", function() { return getBshelves_list; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postMove_sort", function() { return postMove_sort; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(7);


var getBannerList = function getBannerList(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/banner/list',
    method: 'POST',
    data: data
  });
};

var postDeleteRow = function postDeleteRow(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/banner/delete',
    method: 'POST',
    data: data
  });
};

var addBanner = function addBanner(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/banner/save',
    method: 'POST',
    data: data
  });
};

var postUpdateBanner = function postUpdateBanner(data, url) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: url,
    method: 'POST',
    data: data
  });
};

var postEditBanner = function postEditBanner(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/banner/update',
    method: 'POST',
    data: data
  });
};

var getBannerDeletail = function getBannerDeletail(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/banner/get',
    method: 'POST',
    data: data
  });
};

var getBshelves_list = function getBshelves_list() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/banner/shelves_list',
    method: 'POST'
  });
};

var postMove_sort = function postMove_sort(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/banner/move_sort',
    method: 'POST',
    data: data
  });
};

/***/ }),

/***/ 163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBookList", function() { return getBookList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postUpdateBook", function() { return postUpdateBook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postAddBook", function() { return postAddBook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBookRecommendList", function() { return getBookRecommendList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postDeleteBookRecommend", function() { return postDeleteBookRecommend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postAddRecommend", function() { return postAddRecommend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postBookSort", function() { return postBookSort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "listBookRecommendGrade", function() { return listBookRecommendGrade; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(7);


var getBookList = function getBookList(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/book/listBooks',
    method: 'POST',
    data: data
  });
};
var postUpdateBook = function postUpdateBook(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/book/updateBookStatus',
    method: 'POST',
    data: data
  });
};

var postAddBook = function postAddBook(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/book/updateBook',
    method: 'POST',
    data: data
  });
};

var getBookRecommendList = function getBookRecommendList(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/book/listBookRecommend',
    method: 'POST',
    data: data
  });
};

var postDeleteBookRecommend = function postDeleteBookRecommend(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/book/deleteBookRecommend',
    method: 'POST',
    data: data
  });
};

var postAddRecommend = function postAddRecommend(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/book/addBookRecommend',
    method: 'POST',
    data: data
  });
};

var postBookSort = function postBookSort(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/book/moveBookRecommendSequence',
    method: 'POST',
    data: data
  });
};
var listBookRecommendGrade = function listBookRecommendGrade(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/book/listBookRecommendGrade',
    method: 'GET',
    data: data
  });
};

/***/ }),

/***/ 164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNoteList", function() { return getNoteList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDetailList", function() { return getDetailList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDetail", function() { return getDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postDeleteNote", function() { return postDeleteNote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getImgList", function() { return getImgList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addImage", function() { return addImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postDeletrImage", function() { return postDeletrImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "circleList", function() { return circleList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "circleDetail", function() { return circleDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteCircle", function() { return deleteCircle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(7);


var getNoteList = function getNoteList(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/note/list',
    method: 'POST',
    data: data
  });
};

var getDetailList = function getDetailList(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/note/detail/list',
    method: 'POST',
    data: data
  });
};

var getDetail = function getDetail(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/note/detail/get',
    method: 'POST',
    data: data
  });
};

var postDeleteNote = function postDeleteNote(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/note/detail/delete',
    method: 'POST',
    data: data
  });
};

var getImgList = function getImgList(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/image/list',
    method: 'POST',
    data: data
  });
};

var addImage = function addImage(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/image/save',
    method: 'POST',
    data: data
  });
};

var postDeletrImage = function postDeletrImage(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/image/delete',
    method: 'POST',
    data: data
  });
};

var circleList = function circleList(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/literary/circle/list',
    method: 'GET',
    data: data
  });
};

var circleDetail = function circleDetail(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/literary/circle/detail',
    method: 'GET',
    data: data
  });
};
var deleteCircle = function deleteCircle(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/literary/circle/delete',
    method: 'POST',
    data: data
  });
};

/***/ }),

/***/ 165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getExperienceList", function() { return getExperienceList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateParentCorrectCount", function() { return updateParentCorrectCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchUpdate", function() { return batchUpdate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(7);


var getExperienceList = function getExperienceList(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/account/listCorrectUser',
    method: 'POST',
    data: data
  });
};
var updateParentCorrectCount = function updateParentCorrectCount(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/account/updateParentCorrectCount',
    method: 'POST',
    data: data
  });
};
var batchUpdate = function batchUpdate(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/account/batchUpdate',
    method: 'POST',
    data: data
  });
};

/***/ }),

/***/ 166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPull", function() { return getPull; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(7);

var getPull = function getPull(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
        url: '/zyc/ocr/correct/exampaper/pull',
        method: 'get'
    });
};

/***/ }),

/***/ 167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "login", function() { return login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "logout", function() { return logout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changePASS", function() { return changePASS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(7);


var login = function login(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/user/login',
    method: 'POST',
    data: data
  });
};

var logout = function logout() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/logout',
    method: 'get'
  });
};

var changePASS = function changePASS(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/user/modifyPassWord',
    method: 'POST',
    data: data
  });
};

/***/ }),

/***/ 168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postMenu", function() { return postMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "get_role_menu", function() { return get_role_menu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAllMenu", function() { return getAllMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(7);


var postMenu = function postMenu(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/menu/get_menu_by_uid',
    method: 'POST',
    data: data
  });
};

var get_role_menu = function get_role_menu(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/role/get_role_menu',
    method: 'POST',
    data: data
  });
};

var getAllMenu = function getAllMenu(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/menu/get',
    method: 'POST'
  });
};

/***/ }),

/***/ 169:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postRole", function() { return postRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addUser", function() { return addUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteUser", function() { return deleteUser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(7);

var postRole = function postRole(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/role/list',
    method: 'POST',
    data: data
  });
};
var addUser = function addUser(data, url) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: url,
    method: 'POST',
    data: data
  });
};
var deleteUser = function deleteUser(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/manage/role/delete',
    method: 'POST',
    data: data
  });
};

/***/ }),

/***/ 170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserList", function() { return getUserList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createUser", function() { return createUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateUser", function() { return updateUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportUser", function() { return exportUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "listHomeworkClass", function() { return listHomeworkClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "create", function() { return create; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "update", function() { return update; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "listHomeworkStudentClass", function() { return listHomeworkStudentClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeStudentClass", function() { return removeStudentClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "add", function() { return add; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(7);


var getUserList = function getUserList(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/account/listUser',
    method: 'POST',
    data: data
  });
};
var createUser = function createUser(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/account/createUser',
    method: 'POST',
    data: data
  });
};
var updateUser = function updateUser(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/account/updateUser',
    method: 'POST',
    data: data
  });
};
var exportUser = function exportUser(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/account/exportUser',
    method: 'POST',
    data: data
  });
};
var listHomeworkClass = function listHomeworkClass(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/class/listHomeworkClass',
    method: 'POST',
    data: data
  });
};
var create = function create(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/class/create',
    method: 'POST',
    data: data
  });
};
var update = function update(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/class/update',
    method: 'POST',
    data: data
  });
};
var listHomeworkStudentClass = function listHomeworkStudentClass(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/student/class/listHomeworkStudentClass',
    method: 'POST',
    data: data
  });
};
var removeStudentClass = function removeStudentClass(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/student/class/removeStudentClass',
    method: 'POST',
    data: data
  });
};
var add = function add(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])({
    url: '/con/student/class/add',
    method: 'POST',
    data: data
  });
};

/***/ }),

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_index__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_css_reset_css__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_css_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_css_reset_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_font_awesome_css_font_awesome_min_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_font_awesome_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__libs_title__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__http_index__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_quill_editor__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_quill_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_quill_dist_quill_core_css__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_quill_dist_quill_core_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_quill_dist_quill_core_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_quill_dist_quill_snow_css__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_quill_dist_quill_snow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_quill_dist_quill_snow_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_quill_dist_quill_bubble_css__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_quill_dist_quill_bubble_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_quill_dist_quill_bubble_css__);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_quill_editor___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8__http_index__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui___default.a);

__WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (to.meta.title) {
    document.title = to.meta.title;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__libs_title__["a" /* wxSetTitle */])(to.meta.title);
  }
  next();
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: "#app",
  router: __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_2__store_index__["a" /* default */],
  template: "<router-view></router-view>"
});

/***/ }),

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    conUser: {}
  },
  getters: {
    getConUser: function getConUser(state) {
      return conUser;
    }
  }
});

/***/ }),

/***/ 173:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        menuTree: []
    },
    getters: {
        setMenuTree: function setMenuTree(state, menuTree) {
            state.menuTree = menuTree;
        }
    },
    mutations: {
        setMenuTree: function setMenuTree(state, menuTree) {
            state.menuTree = menuTree;
        }
    }
});

/***/ }),

/***/ 58:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_js_cookie__);


var _ref;



var login = function login() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 275));
};
var Home = function Home() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 274));
};
var User = function User() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 284));
};
var ClassManagement = function ClassManagement() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 280));
};
var CreateClass = function CreateClass() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 281));
};
var ManageClass = function ManageClass() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 282));
};
var MemberManagement = function MemberManagement() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 283));
};
var Change = function Change() {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 279));
};
var Book = function Book() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 272));
};
var AddBook = function AddBook() {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 270));
};
var BookRecommend = function BookRecommend() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 271));
};
var EditBook = function EditBook() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 273));
};
var bookAdministration = function bookAdministration() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 116));
};
var Banner = function Banner() {
  return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 266));
};
var ExperienceNote = function ExperienceNote() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 118));
};
var AddBanner = function AddBanner() {
  return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 265));
};
var EditBanner = function EditBanner() {
  return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 268));
};
var BannerSort = function BannerSort() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 267));
};
var ExperienceManagement = function ExperienceManagement() {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 277));
};
var Cutaway = function Cutaway() {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 276));
};
var Roles = function Roles() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 263));
};
var AccountManagement = function AccountManagement() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 262));
};
var McademicBooksManage = function McademicBooksManage() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 259));
};
var McademicBooksInfo = function McademicBooksInfo() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 258));
};
var EditBooksQues = function EditBooksQues() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 260));
};


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: "history",
  routes: [{
    path: "/login",
    name: "Login",
    component: login,
    meta: {
      title: "悠语文管理控制台"
    }
  }, {
    path: "/home",
    name: "当前位置",
    component: Home,
    children: [{
      path: "/user",
      name: "用户中心",
      component: function component(r) {
        return __webpack_require__.e/* require.ensure */(0).then((function () {
          return r(__webpack_require__(64));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      },
      children: [{
        path: "/",
        name: "用户管理",
        component: function component(r) {
          return __webpack_require__.e/* require.ensure */(0).then((function () {
            return r(__webpack_require__(64));
          }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
        },
        meta: {
          title: "用户管理"
        },
        redirect: "/users",
        children: [{
          path: "/user/change",
          name: "查看用户",
          component: Change,
          meta: {
            title: "查看用户"
          }
        }]
      }, {
        path: "/users",
        name: "用户管理",
        component: User,
        meta: {
          title: "用户管理"
        }
      }, {
        path: "/classManagement",
        name: "班级管理",
        component: function component(r) {
          return __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
            return r(__webpack_require__(64));
          }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
        },
        meta: {
          title: "班级管理"
        },
        redirect: "/classManagements",
        children: [{
          path: "/classManagement/createClass",
          name: "创建班级",
          component: CreateClass,
          meta: {
            title: "创建班级"
          }
        }, {
          path: "/classManagement/manageClass",
          name: "编辑班级",
          component: ManageClass,
          meta: {
            title: "编辑班级"
          }
        }, {
          path: "/classManagement/memberManagement",
          name: "成员管理",
          component: MemberManagement,
          meta: {
            title: "成员管理"
          }
        }]
      }, {
        path: "/classManagements",
        name: "班级管理",
        component: ClassManagement,
        meta: {
          title: "班级管理"
        }
      }]
    }, {
      path: "/experienceNotes",
      name: "心得批改管理",
      component: ExperienceNote,
      meta: {
        title: "心得批改管理"
      }
    }, {
      path: "/experienceNote",
      name: "心得批改管理",
      component: function component(r) {
        return __webpack_require__.e/* require.ensure */(1/* duplicate */).then((function () {
          return r(__webpack_require__(118));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      },
      redirect: "/experienceNotes",
      meta: {
        title: "心得批改管理"
      },

      children: []
    }, {
      path: "/book",
      name: "书本资源管理",
      component: function component(r) {
        return __webpack_require__.e/* require.ensure */(3).then((function () {
          return r(__webpack_require__(117));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      },
      children: [{
        path: "/",
        name: "书本管理",
        component: function component(r) {
          return __webpack_require__.e/* require.ensure */(3).then((function () {
            return r(__webpack_require__(117));
          }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
        },
        meta: {
          title: "书本管理"
        },
        redirect: "/books",
        children: [{
          path: "/book/addBook",
          name: "添加书本",
          component: AddBook,
          meta: {
            title: "添加书本"
          }
        }, {
          path: "/book/editBook",
          name: "编辑书本",
          component: EditBook,
          meta: {
            title: "编辑书本"
          }
        }]
      }, {
        path: "/books",
        name: "书本管理",
        component: Book,
        meta: {
          title: "书本管理"
        }
      }, {
        path: "/bookRecommend",
        name: "书本推荐管理",
        component: function component(r) {
          return __webpack_require__.e/* require.ensure */(2/* duplicate */).then((function () {
            return r(__webpack_require__(116));
          }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
        },
        meta: {
          title: "书本推荐管理"
        },
        redirect: "/bookRecommends",
        children: [{
          path: "/bookRecommend/bookAdministration",
          name: "书本推荐管理",
          component: bookAdministration,
          meta: {
            title: "书本推荐管理"
          }
        }]
      }, {
        path: "/bookRecommends",
        name: "书本推荐管理",
        component: BookRecommend,
        meta: {
          title: "书本推荐管理"
        }
      }]
    }, (_ref = {
      path: "/banner",
      name: "banner管理",
      component: function component(r) {
        return __webpack_require__.e/* require.ensure */(28).then((function () {
          return r(__webpack_require__(269));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      },
      redirect: "banners",
      meta: {
        title: "banner管理"
      }
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "redirect", "/banners"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "children", [{
      path: "/banners/addBanner",
      name: "添加banner",
      component: AddBanner,
      meta: {
        title: "添加banner"
      }
    }, {
      path: "/banners/editBanner",
      name: "编辑banner",
      component: EditBanner,
      meta: {
        title: "编辑banner"
      }
    }, {
      path: "/banners/bannerSort",
      name: "banner排序",
      component: BannerSort,
      meta: {
        title: "banner排序"
      }
    }]), _ref), {
      path: "/banners",
      name: "banner管理",
      component: Banner,
      meta: {
        title: "banner管理"
      }
    }, {
      path: "/studentRelease",
      name: "学生发布管理",
      component: function component(r) {
        return __webpack_require__.e/* require.ensure */(27).then((function () {
          return r(__webpack_require__(278));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      },
      meta: {
        title: "banner管理"
      },
      children: [{
        path: "/",
        name: "文学圈管理",
        component: ExperienceManagement,
        meta: {
          title: "文学圈管理"
        }
      }, {
        path: "/cutaway",
        name: "切图管理",
        component: Cutaway,
        meta: {
          title: "切图管理"
        }
      }]
    }, {
      path: "/academicBooks",
      name: "学评书籍管理",
      component: function component(r) {
        return __webpack_require__.e/* require.ensure */(30).then((function () {
          return r(__webpack_require__(261));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      },
      meta: {
        title: "学评书籍管理"
      },
      children: [{
        path: "/",
        name: "学评书籍管理列表",
        component: McademicBooksManage,
        meta: {
          title: "学评书籍管理列表"
        }
      }, {
        path: "/McademicBooksInfo",
        name: "学评书籍管理详情",
        component: McademicBooksInfo,
        meta: {
          title: "学评书籍管理详情"
        }
      }, {
        path: "/editBooksQues",
        name: "书本题目编辑",
        component: EditBooksQues,
        meta: {
          title: "书本题目编辑"
        }
      }]
    }, {
      path: "/roles",
      name: "权限管理",
      component: function component(r) {
        return __webpack_require__.e/* require.ensure */(29).then((function () {
          return r(__webpack_require__(264));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      },
      meta: {
        title: "权限管理"
      },
      children: [{
        path: "/",
        name: "角色管理",
        component: Roles,
        meta: {
          title: "角色管理"
        }
      }, {
        path: "/accountManagement",
        name: "账号管理",
        component: AccountManagement,
        meta: {
          title: "账号管理"
        }
      }]
    }]
  }]
});
router.beforeEach(function (to, from, next) {
  var token = __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.get("token");
  if (token) {
    if (to.path == "/") {
      next("/login");
    } else {
      next();
    }
  } else {
    if (to.path == "/login") {
      next();
    } else {
      next("/login");
    }
  }
});
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 7:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = $axios;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(58);






var baseURL = '/api';
function $axios(options) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var instance = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
      baseURL: baseURL,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      transformResponse: [function (data) {}]
    });

    instance.interceptors.request.use(function (config) {
      var token = __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.get('token');

      if (token) {
        config.headers.token = token;
      } else {
        __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push('/login');
      }

      if (config.method === 'post') {
        if (config.data && config.data.__proto__ === FormData.prototype || config.url.endsWith('path') || config.url.endsWith('mark') || config.url.endsWith('patchs')) {} else {
          config.data = __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(config.data);
        }
      } else {
        config.data = __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(config.data);
        config.url = config.url + '?' + config.data;
      }
      return config;
    }, function (error) {
      console.log('request:', error);

      if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
        console.log('timeout请求超时');
      }

      var errorInfo = error.response;
      console.log(errorInfo);
      if (errorInfo) {
        error = errorInfo.data;
        var errorStatus = errorInfo.status;
        __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push({
          path: '/error/' + errorStatus
        });
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });

    instance.interceptors.response.use(function (response) {
      var data = void 0;

      if (response.data == undefined) {
        data = JSON.parse(response.request.responseText);
      } else {
        data = response.data;
      }
      if (data && data.ret_code === -1) {
        __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push('/login');
        return;
      } else {
        return data;
      }
    }, function (err) {
      if (err && err.response) {
        switch (err.response.status) {
          case 400:
            err.message = '请求错误';
            break;
          case 401:
            err.message = '未授权，请登录';
            break;
          case 403:
            err.message = '拒绝访问';
            break;
          case 404:
            err.message = '\u8BF7\u6C42\u5730\u5740\u51FA\u9519: ' + err.response.config.url;
            break;
          case 408:
            err.message = '请求超时';
            break;
          case 500:
            err.message = '服务器内部错误';
            break;
          case 501:
            err.message = '服务未实现,请登录';
            __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push('/login');
            break;
          case 502:
            err.message = '网关错误';
            break;
          case 503:
            err.message = '服务不可用';
            break;
          case 504:
            err.message = '网关超时';
            break;
          case 505:
            err.message = 'HTTP版本不受支持';
            break;
          default:
        }
      }
      console.error(err);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
    });

    instance(options).then(function (res) {
      resolve(res);
      return false;
    }).catch(function (error) {
      reject(error);
    });
  });
}

/***/ }),

/***/ 99:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(159);




var install = function install(Vue) {
  if (install.installed) return;

  install.installed = true;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(Vue.prototype, {
    $api: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */];
      }
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = (install);

/***/ })

},[171]);


// WEBPACK FOOTER //
// static/js/app.3ad85842ad44a25d8428.js